import { useEffect } from 'react'

// Updates the height of a <textarea> when the value changes.
const useAutosizeTextAreaHeight = (
  textAreaRef: HTMLTextAreaElement | null,
  value: string,
  customHeight: string
) => {
  useEffect(() => {
    if (textAreaRef) {
      // Reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.style.height = '0px'
      const scrollHeight = textAreaRef.scrollHeight

      // Use customHeight if provided, otherwise subtract 20px for a margin
      if (customHeight) {
        textAreaRef.style.height = scrollHeight + 'px'
      } else {
        textAreaRef.style.height = scrollHeight - 20 + 'px'
      }
    }
  }, [textAreaRef, value])
}

export default useAutosizeTextAreaHeight
